import * as React from 'react';
import { getVehicleTypeIcon } from '~/helpers/vehiclesApi';
import { default as globalStyles } from '~/styles/global.scss';
import classNames from 'classnames';
import { getLevelFromRomanFormat } from '~/helpers/levels';
import { PermoflageVehicles } from '~/vortex';

export const getVehicles = (vehicles: PermoflageVehicles[]) => {
    const items = [...vehicles].splice(0, 3);

    return (
        <React.Fragment>
            {items.map((item) => {
                const nationStyle = {
                    backgroundImage: `url(${item.vehicle.nation.icons.tiny})`,
                };
                const typeIcon = {
                    backgroundImage: `url(${getVehicleTypeIcon(item.vehicle)})`,
                };

                const classNameTitle = classNames(globalStyles.tooltipVehicleTitle, {
                    [globalStyles.gold]: item.vehicle.isPremium || item.vehicle.isSpecial,
                });

                return (
                    <div className={globalStyles.tooltipContentIconsWrap} key={item.vehicle.title}>
                        <span className={globalStyles.smallIconNation} style={nationStyle} />
                        <span className={globalStyles.smallIconType} style={typeIcon} />
                        <span className={classNameTitle}>
                            {getLevelFromRomanFormat(item.vehicle.level)} {item.vehicle.titleShort}
                        </span>
                    </div>
                );
            })}
            {vehicles.length > 3 && <div>...</div>}
        </React.Fragment>
    );
};
